/* eslint-disable react/prop-types */
import { Box, useMediaQuery } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import OrganizationStructure from "../../../components/common/OrganizationStructure/OrganizationStructureV2";
import { OS_DROPDOWN_KEYS, TRANSFER_OS_DROPDOWN_KEYS } from "../../../contants";
import useQueryParams from "../../../hooks/useQueryParams";
import { selectUserProfile } from "../../../redux/selectors/user";
import { isEmptyObj } from "../../../utils/helper";
import { TARGET_ORGANIZATION_STRUCTURE_FIELDS } from "../../../contants/formFields";

function OrganizationSearch({
  values,
  handleChange,
  errors,
  setFieldValue,
  disabledOSKeys = [],
}) {
  const [shouldFetchOtherOS, setShouldFetchOtherOS] = useState(false);
  const { getQueryObject, getQueryParams, urlSearchParams } = useQueryParams();
  const userData = useSelector(selectUserProfile);

  const isMobile = useMediaQuery("(max-width: 768px)");

  const preselectOSKeys = () => {
    if (disabledOSKeys.length && !isEmptyObj(userData)) {
      disabledOSKeys.forEach((key) => {
        if (userData[key]) {
          setFieldValue(key, userData[key]);
        }
      });
      setShouldFetchOtherOS(true);
    }
  };

  // SSR
  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      OS_DROPDOWN_KEYS.forEach((key) => {
        setFieldValue(key, Number(query[key]));
      });
      setShouldFetchOtherOS(true);
    } else {
      OS_DROPDOWN_KEYS.forEach((key) => {
        if (!disabledOSKeys.includes(key)) {
          setFieldValue(key, "");
        }
      });
      preselectOSKeys();
    }
  }, [urlSearchParams.toString(), disabledOSKeys, userData]);

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      TRANSFER_OS_DROPDOWN_KEYS.forEach((key) => {
        setFieldValue(key, Number(query[key]));
      });
      setShouldFetchOtherOS(true);
    } else {
      TRANSFER_OS_DROPDOWN_KEYS.forEach((key) => {
        if (!disabledOSKeys.includes(key)) {
          setFieldValue(key, "");
        }
      });
      preselectOSKeys();
    }
  }, [urlSearchParams.toString(), disabledOSKeys, userData]);

  return (
    <OrganizationStructure
      values={values}
      handleChange={handleChange}
      errors={errors}
      setFieldValue={setFieldValue}
      showZoneLocator={false}
      showTitle={false}
      containerStyle={{
        border: "none",
        padding: "0px 18px 0px 0px",
        display: "grid",
        gridTemplateColumns: isMobile ? "1fr" : "repeat(6, 1fr)",
        columnGap: isMobile ? "0px" : "6px",
        rowGap: isMobile ? "0px" : "0px",
        alignItems: "flex-start",
      }}
      required={false}
      useHiddenInput
      storeValuesInRedux
      showBlock
      shouldFetchOtherOS={shouldFetchOtherOS}
      disabledOSKeys={disabledOSKeys}
      formFieldNames={TARGET_ORGANIZATION_STRUCTURE_FIELDS}
    />
  );
}

function OrganizationSearchWrapper({ disabledOSKeys = [] }) {
  return (
    <Box
      sx={{
        "& .MuiFormLabel-root": {
          fontSize: "12px !important",
          fontWeight: "600 !important",
        },
        "& .MuiOutlinedInput-input": {
          height: "14px",
        },
        "& .MuiInputBase-input": {
          fontSize: "12px  !important",
          fontWeight: 600,
        },
      }}
    >
      <Formik initialValues={{}}>
        {({ values, errors, handleChange, setFieldValue }) => (
          <OrganizationSearch
            values={values}
            errors={errors}
            handleChange={handleChange}
            setFieldValue={setFieldValue}
            disabledOSKeys={disabledOSKeys}
            formFieldNames={TARGET_ORGANIZATION_STRUCTURE_FIELDS}
          />
        )}
      </Formik>
    </Box>
  );
}

export default OrganizationSearchWrapper;
